"use client";

import { useSearchParams, usePathname, useRouter } from "next/navigation";

export function useUpdateSearchParam() {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const { replace } = useRouter();

  return (key: string, value: string) => {
    const params = new URLSearchParams(searchParams.toString());

    if (value) {
      params.set(key, value); // Update or add param
    } else {
      params.delete(key); // Remove param if value is empty
    }

    replace(`${pathname}?${params.toString()}`, { scroll: false });
  };
}
